import React from "react";
import { Lock, Sparkles } from "lucide-react";
import BondPlayStageHeader from "../bond-play/BondPlayStageHeader";

const BondDrawStageHeader = ({
  picks = 0,
  maxSelection = 6,
  hasPending = false,
  hitPct = 0,
  onOpenInfo,
}) => {
  const slots = Array.from({ length: maxSelection }, (_, index) => index < picks);

  return (
    <BondPlayStageHeader
      helpLabel="How Bond Draw works"
      onOpenInfo={onOpenInfo}
      kicker={
        hasPending ? (
          <>
            <Lock size={10} strokeWidth={2.5} /> Reserved ticket
          </>
        ) : (
          <>
            <Sparkles size={10} strokeWidth={2.5} /> Bond Draw
          </>
        )
      }
      title={hasPending ? "Draw before time runs out" : `Pick up to ${maxSelection} numbers`}
      subtitle={
        hasPending
          ? `${picks} number${picks === 1 ? "" : "s"} locked on your ticket`
          : picks === 0
            ? "Tap a number above to build your ticket"
            : hitPct > 0
              ? `${picks} of ${maxSelection} · ${hitPct}% hit — add more or reserve`
              : `${picks} of ${maxSelection} selected — add more or reserve`
      }
    >
      {!hasPending ? (
        <div className="bplay-stage-header-slots" aria-label={`${picks} of ${maxSelection} numbers selected`}>
          {slots.map((filled, index) => (
            <span key={`slot-${index}`} className={`bplay-stage-slot${filled ? " filled" : ""}`} />
          ))}
        </div>
      ) : null}
    </BondPlayStageHeader>
  );
};

export default BondDrawStageHeader;
